<div class="dashboard">
  @if (!groupMode) {
  <top-bar
    [showSessionSyncButton]="canUseTwoToOneSessionSync()"
    [sessionSyncRunning]="isTwoToOneSessionSyncRunning()"
    (sessionSyncToggle)="toggleTwoToOneSessionSync()"
  ></top-bar>
  }

  @if (!isPreview && (!sessionID || !patientID)) {
  <div class="text-center w-100 mt-5 text-danger">
    Invalid session or patient
  </div>
  }
  
  @if (!loading && sessionID && patientID && isSessionDeleted()) {
    <div class="text-center w-100 mt-5 text-danger mb-5">
      Session Deleted. Redirecting to sessions...
    </div>
  }
  @if (sessionID && patientID && isSessionFinished()) {
  <div class="text-center w-100 mt-5 text-danger mb-5">
    @if (loading) {
    <app-loading-indicator />
    } @else {
      @if (justFinishedSession) {
      Session finished, redirecting...
      }
      @else {
      Session finished.
      }
    }
  </div>
  } @else {

  <div class="float-right me-3" *ngIf="!lightLoad.isEnabled()">
    <p-button (onClick)="bip.toggle($event)" label="BIP" id="bipComponentsButton" severity="success" [outlined]="true"
      [style]="{
        'border-radius': '5px',
        'font-weight': 'bold',
        
      }" />
    <p-overlayPanel #bip>
      <div class="side-menu-buttons">
        <a class="main-button" (click)="openBipView('QuickReference'); bip.hide()">
          <span>Quick Reference</span>
        </a>
        <a class="main-button" (click)="openBipView('Behaviors'); bip.hide()">
          <span>Behaviors</span>
        </a>
        <a class="main-button" (click)="openBipView('CrisisCycle'); bip.hide()">
          <span>Crisis Cycle</span>
        </a>
        <a class="main-button" (click)="openBipView('EmergencyProcedures'); bip.hide()">
          <span>Emergency Procedures</span>
        </a>
        <a class="main-button" (click)="openBipView('AdditionalInfo'); bip.hide()">
          <span>Additional Information</span>
        </a>
      </div>
    </p-overlayPanel>

  </div>

  <div class="float-right me-3 d-flex">
    <button class="badge-patient-instructions pointer ms-2" title="Reload Data"
      (click)="reloadData()"><i class="pi pi-refresh"></i></button>
     <button *ngIf="!lightLoad.isEnabled()" class="badge-patient-instructions pointer ms-2" title="Patient Instructions"
      (click)="openPatientInstructions()">?</button>
    </div>
  <div class="flags-container" *ngIf="(isPreview || (sessionID && patientID)) && !loading">
    <div class="flags">
      <div *ngIf="!groupMode" class="top-box" id="startEndSessionButton">
        <div class="flag flex-column">
          <div *ngIf="!isStarted()">
            Session
            <button class="button-start" (click)="startSession()">Start</button>
          </div>
          <div *ngIf="isStarted()">
            {{ timerString() }}
            <button class="button-end" (click)="endSession()">End</button>
          </div>
        </div>
      </div>

      <div class="flags-horizontal-w100" *ngIf="isStarted()" id="favoriteTargetsList">
        @for (target of favoriteTargets; track target.ID) {
        <app-target-selector [target]="target" [isBottomBox]="false" [promptCodes]="target.PromptCodes??[]"
          [subTargetsDictionary]="subTargetsDictionary" [allPromptCodes]="target.AllPromptCodes??[]"
          [promptSchedules]="promptSchedules" [isPreview]="isPreview"></app-target-selector>
        }
      </div>
    </div>
  </div>

  <div class="flags" *ngIf="isStarted()">
    @if(specialFavoriteTargets.length > 0){
    <div class="flags-horizontal" id="specialFavoriteTargetsList">
        @for (target of specialFavoriteTargets; track target.ID) {
          <app-target-selector [target]="target" [isBottomBox]="false" [promptCodes]="target.PromptCodes??[]"
          [subTargetsDictionary]="subTargetsDictionary" [allPromptCodes]="target.AllPromptCodes??[]" [promptSchedules]="promptSchedules" [isPreview]="isPreview"></app-target-selector>
        }
      </div>
    }
    <div class="flags-horizontal" id="behaviorsList" [class.flags-horizontal]="specialFavoriteTargets.length > 0" [class.flags-horizontal-w100]="specialFavoriteTargets.length == 0">
      @for (behavior of behaviors; track behavior.ID) {
      @if(isFrequencyBehavior(behavior)) {
      <app-box-behavior-frequency [text]="behavior.PatientBehaviorName ?? ''" [showDayValue]="false"
        [behaviorID]="behavior.ID ?? 0" [behavior]="behavior" [isPreview]="isPreview"></app-box-behavior-frequency>
      }
      @if(isDurationBehavior(behavior)) {
      <app-box-behavior-duration [text]="behavior.PatientBehaviorName ?? ''" [behaviorID]="behavior.ID ?? 0"
        [behavior]="behavior" [isPreview]="isPreview"></app-box-behavior-duration>
      }
      @if(isIntervalBehavior(behavior)) {
      <app-box-behavior-interval [text]="behavior.PatientBehaviorName ?? ''" [behaviorID]="behavior.ID ?? 0"
        [behavior]="behavior" [isPreview]="isPreview" [Duration]="behavior.Interval ?? 0"></app-box-behavior-interval>
      }
      @if(isRateTimerBehavior(behavior)) {
      <app-box-behavior-ratetimer [text]="behavior.PatientBehaviorName ?? ''" [behaviorID]="behavior.ID ?? 0"
        [behavior]="behavior" [isPreview]="isPreview" [Duration]="behavior.Interval ?? 0"></app-box-behavior-ratetimer>
      }
      @if(isIntensityBehavior(behavior)) {
      <app-box-behavior-intensity [text]="behavior.PatientBehaviorName ?? ''" [behaviorID]="behavior.ID ?? 0"
        [behavior]="behavior" [isPreview]="isPreview"></app-box-behavior-intensity>
      }

      }
    </div>
  </div>

  @if (isStarted()) {
  <div class="reminder-container">
    @for (reminder of showingReminders; track reminder.ID) {
    <div class="alert alert-danger" role="button" (click)="closeReminder(reminder)">
      @if (reminder.Message?.trim()) {
      <span class="m-0 p-0">{{ reminder.Message }}</span>
      } @else {
      <span class="m-0 p-0">{{ reminder.Name + " (Reminder name shown because the message was empty)" }}</span>
      }
    </div>
    }
  </div>
  }
  <div class="programs" *ngIf="isStarted()">

    @if(selectedPlaylistIndex >= 0 && this.filteredPlaylists[selectedPlaylistIndex]) {
      <div class="d-flex align-items-center" style="margin-top: -13px; margin-left: -10px; margin-bottom: -15px;">
        @if (!lightLoad.isEnabled()) {
          <button class="badge-program-details me-1 pointer" (click)="$event.stopPropagation(); openPlaylistDetails()">?</button>
        }
        <div class="program-title">Playlist: {{ this.filteredPlaylists[selectedPlaylistIndex].PlaylistName }}</div>        
      </div>
    }
    @for (itemArea of groupedShowingItems; track itemArea.Title){

    <div class="program-title">{{ itemArea.Title }}</div>
    @for (item of itemArea.items; track item.ProgramID) {
    <div class="program-name">
      @if(item.ProgramID) {
      <div class="float-right d-flex ">
        <small>Show Hidden Maintenance Targets</small> <p-checkbox class="ms-2 mr30"
          [ngModel]="showMaintenanceTargetsOnProgram[item.ProgramID]"
          (ngModelChange)="toggleShowMaintenanceTargets(item.ProgramID)" binary="true"></p-checkbox>
        <small>Show Mastered Targets</small> <p-checkbox class="ms-2"
          [ngModel]="showMasteredTargetsOnProgram[item.ProgramID]"
          (ngModelChange)="toggleShowMasteredTargets(item.ProgramID)" binary="true"></p-checkbox>
        <button class="badge-program-details pointer ms-2" (click)="openProgramDetails(item)">?</button>
      </div>
      }
      {{ item.Name }}
    </div>
    <div class="program-items">
      @for (target of item.Targets; track target.ID) {
        @if(!target.IsTargetSubtarget) {
          @if(!!!isMaintenaceTaken(target, item.ProgramID) || (item.ProgramID && item.ShowMaintenanceTargets)){
            @if(target.TargetStatus != PatientTargetStatus.Mastered || (item.ProgramID && item.ShowMasteredTargets)) {
              <app-target-selector [target]="target" [isBottomBox]="true" [promptCodes]="target.PromptCodes??[]"
                [subTargetsDictionary]="subTargetsDictionary" [allPromptCodes]="target.AllPromptCodes??[]"
                [promptSchedules]="promptSchedules" [isPreview]="isPreview"></app-target-selector>
            }
          }
        }
      }
    </div>
    @if (item.ProgramID && !lightLoad.isEnabled()){
    <div class="program-notes" (click)="showProgramNotes(programNotesDiv, programNotesTextarea, item)"
      (clickOutside)="hideProgramNotes(programNotesDiv, programNotesTextarea)" #programNotesDiv>
      <div class="d-flex justify-content-between align-items-center">
        <span>Program Notes: <i style="font-size: 12px; opacity: 0.5;">{{ lastModifiedByTextForProgram(item) +
            (item.ProgramNotesLastModifiedDate != '' ? (item.ProgramNotesLastModifiedDate | date:'MM/dd/yyyy hh:mm a') :
            '') }}</i>
          <i class="pi pi-arrow-down" *ngIf="!programNotesTextarea.classList.contains('focused')"></i>
        </span>
        <div class="d-flex gap-2" *ngIf="!isPreview">
          <button *ngIf="isProgramNotesShowing && !isEditingProgramNotes" pButton
            class="p-button-outlined side-menu-button2" icon="pi pi-pencil"
            [disabled]="item.ProgramNotes == null || isLoadingProgramNotes"
            (click)="startEditingProgramNotes()">
            &nbsp;Edit
          </button>
          <div *ngIf="isEditingProgramNotes" class="d-flex gap-2">
            <button pButton class="p-button-outlined side-menu-button2" icon="pi pi-check"
              [disabled]="item.ProgramNotes == null"
              (click)="saveProgramNotes(item.ProgramID, item.ProgramNotes)">
              &nbsp;Save
            </button>
            <button pButton class="p-button-outlined switch-mode-button" icon="pi pi-times"
              (click)="cancelEditingProgramNotes()">
              &nbsp;Cancel
            </button>
          </div>
        </div>
      </div>
      @if (item.ProgramNotes == null && isProgramNotesShowing) {
        <div class="d-flex align-items-center gap-2 text-muted p-2" role="status">
          <div class="spinner-border spinner-border-sm text-primary" aria-hidden="true"></div>
          <span>Loading program notes...</span>
        </div>
      }
      <textarea class="program-notes-textarea" #programNotesTextarea
        [hidden]="item.ProgramNotes == null"
        [ngModel]="item.ProgramNotes"
        (ngModelChange)="onProgramNotesChanged(item, $event)"
        [disabled]="!isEditingProgramNotes || item.ProgramNotes == null"></textarea>
    </div>
    }
    @if (item.TargetID && !lightLoad.isEnabled()){
    <div class="program-notes target-note-thread-menu">
      <div class="d-flex justify-content-between align-items-center">
        <span>Target Notes:</span>
      </div>
      <app-target-note-thread
        [targetId]="item.TargetID"
        [patientId]="patientID"
        [targetNotes]="item.TargetNotes"
        [notesLastModifiedByUserFullName]="item.TargetNotesLastModifiedByUserFullName"
        [notesLastModifiedDate]="item.TargetNotesLastModifiedDate"
        [readOnly]="isPreview"
        [shouldMarkAsNew]="true"
        (latestMessageChanged)="onMenuTargetNoteChanged(item, $event)"
      ></app-target-note-thread>
    </div>
    }

    } }
  </div>

  <div class="programs-list-container" *ngIf="isStarted()">
    <div class="programs-list">
      @for (playlist of filteredPlaylists; track playlist.ID; let i = $index) {
      <div class="program-list-item" (click)="selectPlaylist(playlist)" [class.selected]="i == selectedPlaylistIndex">
        <div class="program-list-item-title">Playlist</div>
        <div class="program-list-item-name">{{ playlist.PlaylistName }}</div>
        <div class="program-list-item-circles"></div>
        @if (!lightLoad.isEnabled()) {
          <button class="badge-bottom-left pointer" (click)="$event.stopPropagation(); openPlaylistDetails()">?</button>
        }
      </div>
      }
      @for (program of filteredPrograms; track program.ID; let i = $index) {
      <div class="program-list-item" (click)="selectProgram(program)" [class.selected]="i == selectedProgramIndex">
        <span class="badge-count" [class.badge-count-green]="
            countFinishedTrialsTargets(program) >= (program.Targets?.length ?? 0)
          " [class.badge-count-red]="
          countFinishedTrialsTargets(program) < (program.Targets?.length ?? 0)
          ">{{ countFinishedTrialsTargets(program) }}/{{
          program.Targets?.length ?? 0
          }}</span>
        <div class="program-list-item-title">Program</div>
        <div class="program-list-item-name">{{ program.ProgramName }}</div>
        <div class="program-list-item-circles">
          @for (counter of program.Counters; track counter.targetStatus) {
          <div class="program-list-item-circle" [style.background-color]="counter.color">
            {{ counter.count }}
          </div>
          }
        </div>
      </div>
      } @for (target of filteredTargets; track target.ID; let i = $index) {
      <div class="program-list-item" (click)="selectTarget(target)" [class.selected]="i == selectedTargetIndex">
        <div class="program-list-item-title">Target</div>
        <div class="program-list-item-name">{{ target.TargetName }}</div>
        <div class="program-list-item-circles"></div>
      </div>
      }
    </div>
    <div class="programs-list-buttons">
      <input type="text" class="programs-list-search form-control" [(ngModel)]="filterText"
        (ngModelChange)="filterPrograms()" placeholder="Search" *ngIf="showFilterDialog" />

      <div class="programs-list-clearsearch" (click)="clearSearchInput()" *ngIf="showFilterDialog">
        <i class="pi pi-times-circle" style="pointer-events: all;"></i>
      </div>
      <button class="programs-list-button" [class.active]="filterText.length > 0" (click)="showFilter()">
        Search
      </button>
      <button class="programs-list-button" (click)="nextOnList()">Next</button>
    </div>
  </div>
  }
</div>

<div class="progress-note" (clickOutside)="hideProgressNote()" *ngIf="supportProgressNote() && isStarted() && !loading">
  <div class="progress-note-text" (click)="showProgressNote()" [class.hide]="showingProgressNote">
    <span>Progress Note </span>
    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <i class="pi pi-arrow-right"></i></span>
  </div>

  <div class="progress-note-text" (click)="hideProgressNote()" [class.hide]="!showingProgressNote">
    <span>Progress Note </span>
    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="pi pi-arrow-left"></i></span>
  </div>
  <app-progress-note class="progress-note-inner" [isPreview]="isPreview" [PatientSessionID]="patientSession?.ID ?? 0"
    #progressNoteComponent (endSessionEvent)="endSession()" [targets]="targets" [behaviors]="behaviors"
    [programs]="programs" />
</div>
@if (showEndSession) {
<div class="staff-dialog-backdrop" (click)="onCloseEndSession()"></div>
<p-dialog header="End Session - Handoff" class="staff-dialog" [closable]="false" [visible]="true">
  <app-end-session
    [groupMode]="groupMode"
    (close)="onCloseEndSession()"
    (finished)="onEndSessionFinished()"
  />
</p-dialog>
}

@if (loading || isStartingSession) {
<app-loading-indicator />
}


@if (detailsOpened) {
<app-target-details [program]="programToShowDetails" (onCloseDetails)="onCloseDetails()" [isPreview]="isPreview"></app-target-details>
}

@if (playlistDetailsOpened) {
<div class="details-dialog-backdrop" (click)="closePlaylistDetails()"></div>
<dialog class="details-dialog" open>
  <h5 class="w-100 text-center">Playlist Instructions</h5>
  <div class="patient-instructions-body bg-white ">
    @if (isLoadingPlaylistContent && playlistToShowDetails?.Details == null) {
      <div class="d-flex align-items-center gap-2 text-muted p-3" role="status">
        <div class="spinner-border spinner-border-sm text-primary" aria-hidden="true"></div>
        <span>Loading playlist instructions...</span>
      </div>
    } @else {
      <div class="ck ck-content text-black p-5 patient-staff-instructions border-small-rounded"
        [innerHTML]="this.sanitizer.bypassSecurityTrustHtml(playlistToShowDetails?.Details ?? '')"></div>
    }
  </div>
  <div class="d-flex justify-content-end mt-2">
    <button class="side-menu-button2" (click)="closePlaylistDetails()">Close</button>
  </div>
</dialog>
}

<app-attachment-view
  [doShowAttachmentView]="doShowAttachmentView"
  [attachment]="selectedAttachment"
  [canDelete]="false"  
  [view]="'patientInstructionAttachment'"
  (close)="closeAttachmentView()"
></app-attachment-view>

@if (patientInstructionsOpened && !lightLoad.isEnabled()) {
<div class="details-dialog-backdrop" (click)="closePatientInstructions()"></div>
<dialog class="details-dialog" open>
  <h5 class="w-100 text-center">Patient General Instructions</h5>
  <div class="patient-instructions-body bg-white ">
    @if (isLoadingPatientInstructions && !hasLoadedPatientInstructions) {
      <div class="d-flex align-items-center gap-2 text-muted p-3" role="status">
        <div class="spinner-border spinner-border-sm text-primary" aria-hidden="true"></div>
        <span>Loading patient instructions...</span>
      </div>
    } @else {
      <div class="ck ck-content text-black p-5 patient-staff-instructions border-small-rounded"
      [innerHTML]="this.sanitizer.bypassSecurityTrustHtml(patientInstructions)"></div>
    }
  </div>
  @if(!isOfflineMode){
    <div style="width: 100%">
      <div class="att-list-container background-set-white border-small-rounded mt15">
        @if (isLoadingPatientInstructionAttachments && !hasLoadedPatientInstructionAttachments) {
          <div class="d-flex align-items-center gap-2 text-muted p-2" role="status">
            <div class="spinner-border spinner-border-sm text-primary" aria-hidden="true"></div>
            <span>Loading attachments...</span>
          </div>
        }
        @for (att of instructionFiles; track att.ID) {
          <div class="att-box" role="button" (click)="openAttachmentView(att)">
            @if(att.IsImage){
              <img class="m-2" [src]="getImageUrl(att)" style="min-width: 40px; min-height: 40px; max-width: 40px; max-height: 40px;">
            }
            @else{
              <i class="m-0 p-0 pi pi-file-o" style="font-size: 25px; color: black;"></i>
            }
          </div>
        }
      </div>
    </div>
  }
</dialog>
}

@if (showBipDialog && !lightLoad.isEnabled()) {
<div class="details-dialog-backdrop" (click)="closeBipView()"></div>
<dialog class="details-dialog" open>
  <div class="patient-instructions-body bg-white ">
    @if (bipView === 'QuickReference') {
      <app-bip-quick-reference [patientID]="(patientID ?? 0).toString()" [showToggle]="false" [isInStaffContext]="true" (strategySelected)="onQuickRefStrategySelected($event)" />
    }
    @if (bipView === 'Behaviors') {
      <app-bip-behaviors [patientID]="(patientID ?? 0).toString()" [showDraftToggle]="false" [scrollFragment]="bipScrollFragment" [useOfflineData]="isOfflineMode" />
    }
    @if (bipView === 'CrisisCycle') {
      <app-bip-crisis-cycle [patientID]="(patientID ?? 0).toString()" [showToggle]="false" [useOfflineData]="isOfflineMode" />
    }
    @if (bipView === 'EmergencyProcedures') {
      <app-bip-emergency-procedures [patientID]="(patientID ?? 0).toString()" [showToggle]="false" [useOfflineData]="isOfflineMode" />
    }
    @if (bipView === 'AdditionalInfo') {
      <app-bip-additional-info [patientID]="(patientID ?? 0).toString()" [showToggle]="false" [useOfflineData]="isOfflineMode" />
    }
  </div>
  <div class="d-flex justify-content-end mt-2">
    <button class="side-menu-button2" (click)="closeBipView()">Close</button>
  </div>
</dialog>
}
